import { useTranslation } from 'react-i18next';

export function YouAreClear() {
  const { t } = useTranslation();

  return (
    <div
      role="status"
      style={{
        textAlign: 'center',
        padding: 'var(--space-2xl)',
        maxWidth: '480px',
        margin: '0 auto',
      }}
    >
      <h2
        style={{
          fontFamily: 'var(--font-display)',
          fontSize: '1.75rem',
          marginBottom: 'var(--space-sm)',
          color: 'var(--color-text-primary)',
        }}
      >
        {t('items:clear.title')}
      </h2>
      <p style={{ color: 'var(--color-text-secondary)', fontSize: '1rem' }}>
        {t('items:clear.subtitle')}
      </p>
    </div>
  );
}
